import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../../Art57Node/Art57Node";
import { BaseNode } from "../../BaseNode";
import { OnDemandArt57NodeList } from "./OnDemandArt57NodeList";
import { OnDemandAutoUploadNode } from "../OnDemandAutoUploadNode";


export class TreeNodeMedicinalProductsAbstractDevelopmentProductList extends OnDemandArt57NodeList {
    constructor(injector: Injector, parent: BaseNode) {
      super(injector, new ListView(), 'Development Medicinal Products ({param})');
      this.parent = parent;
      this.labelNodeName = 'Development Medicinal Products';
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
      if (this.parent) {
        (this.parent as Art57Node).refreshLabel();
      }
    }
          
    override getHeaders(): string[] {
      return ["EV Code", "Version", "Version Status", "Version Validity", "Full Presentation Name","Product Short Name"];
    }
    override getOnDemandEntities() {
        const entitiesArray:any[] = [];
        this.children?.forEach(child=>{
            const onDemandEntities: any = (child as OnDemandAutoUploadNode).getOnDemandEntities();
            entitiesArray.push(onDemandEntities);
        });
        
        return {developmentmedicalproducts: {developmentmedicalproduct: entitiesArray}};
    }
    
  }